module.exports = __webpack_public_path__ + "img/logo-osoc-color.7e547902.svg";